import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightBulb: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLightBulb"><Path d="M8.5 21.5H15.5M15.25 15.5H8.75M19.5 9C19.5 4.85786 16.1421 1.5 12 1.5C7.85786 1.5 4.5 4.85786 4.5 9C4.5 11.878 6.1211 14.3775 8.5 15.635V18.5H15.5V15.635C17.8789 14.3775 19.5 11.878 19.5 9Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconLightBulb;
